import e, { useState as n, useCallback as r } from "react";
import o from "prop-types";
import { PopoverProvider as t, usePopoverContext as a, PortalContextProvider as i } from "@leafygreen-ui/leafygreen-provider";
import { css as l, cx as c } from "@leafygreen-ui/emotion";
import { uiColors as s, palette as u } from "@leafygreen-ui/palette";
import p from "focus-trap-react";
import { Transition as f } from "react-transition-group";
import { transparentize as d } from "polished";
import m from "@leafygreen-ui/portal";
import y from "@leafygreen-ui/icon/dist/X";
import g from "@leafygreen-ui/icon-button";
import { useIdAllocator as b, useEscapeKey as h } from "@leafygreen-ui/hooks";
import { fontFamilies as v } from "@leafygreen-ui/tokens";
import { createUniqueClassName as x } from "@leafygreen-ui/lib";

function O(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function k(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function w() {
  return w = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
      }
    }

    return e;
  }, w.apply(this, arguments);
}

function j(e, n) {
  if (null == e) return {};

  var r,
      o,
      t = function (e, n) {
    if (null == e) return {};
    var r,
        o,
        t = {},
        a = Object.keys(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], n.indexOf(r) >= 0 || (t[r] = e[r]);
    }

    return t;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (o = 0; o < a.length; o++) {
      r = a[o], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
    }
  }

  return t;
}

function C(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function E(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var o,
        t,
        a = [],
        i = !0,
        l = !1;

    try {
      for (r = r.call(e); !(i = (o = r.next()).done) && (a.push(o.value), !n || a.length !== n); i = !0) {
        ;
      }
    } catch (e) {
      l = !0, t = e;
    } finally {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw t;
      }
    }

    return a;
  }(e, n) || function (e, n) {
    if (!e) return;
    if ("string" == typeof e) return N(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return N(e, n);
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function N(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, o = new Array(n); r < n; r++) {
    o[r] = e[r];
  }

  return o;
}

var A,
    D,
    I = ["open", "size", "setOpen", "shouldClose", "darkMode", "children", "className", "contentClassName", "initialFocus", "closeIconColor"],
    P = {
  Default: "default",
  Dark: "dark",
  Light: "light"
},
    M = {
  Small: "small",
  Default: "default",
  Large: "large"
};

function S(n) {
  var r = function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = null != arguments[n] ? arguments[n] : {};
      n % 2 ? O(Object(r), !0).forEach(function (n) {
        k(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O(Object(r)).forEach(function (n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }

    return e;
  }({
    open: n.open,
    size: n.size,
    setOpen: n.setOpen,
    shouldClose: n.shouldClose,
    darkMode: n.darkMode,
    children: n.children,
    className: n.className,
    contentClassName: n.contentClassName,
    initialFocus: n.initialFocus,
    closeIconColor: n.closeIconColor
  }, j(n, I));

  return e.createElement(t, null, e.createElement(xe, r));
}

S.displayName = "Modal", S.propTypes = {
  open: o.bool,
  size: o.string,
  children: o.node,
  shouldClose: o.func,
  className: o.string,
  setOpen: o.func
};

var z = l(A || (A = C(["\n  position: relative;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: right;\n  flex-direction: row-reverse;\n  padding: 24px 35px 35px;\n"]))),
    F = function F(n) {
  var r = n.children,
      o = n.className,
      t = n.darkMode;
  return e.createElement("div", {
    className: c(z, k({}, l(D || (D = C(["\n            padding: 16px 24px;\n            border-top: 1px solid ", ";\n          "])), s.gray.dark2), t), o)
  }, r);
};

F.displayName = "Footer";

var T,
    L,
    R,
    B,
    U,
    V,
    X,
    $,
    q,
    G,
    H,
    J,
    K,
    Q,
    W,
    Y,
    Z,
    _,
    ee,
    ne,
    re,
    oe,
    te,
    ae,
    ie = ["open", "size", "setOpen", "shouldClose", "darkMode", "children", "className", "contentClassName", "initialFocus", "closeIconColor"],
    le = "dark",
    ce = "light",
    se = function (e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = n.literal,
      o = n.overlap,
      t = r ? e : ["&"].concat(e);

  function a(e) {
    if ("object" != typeof e || null == e) return [];
    if (Array.isArray(e)) return e.map(a);
    var n = {},
        i = {},
        l = {};
    return Object.keys(e).forEach(function (c) {
      var s = e[c];

      if (!Array.isArray(s) && r && (s = [s]), (r || Array.isArray(s)) && 38 !== c.charCodeAt(0)) {
        var u = void 0;
        s.forEach(function (e, a) {
          if ((!o || u !== e) && null != e) if (u = e, 0 !== a || r) {
            if (void 0 === n[t[a]]) {
              var i;
              n[t[a]] = ((i = {})[c] = e, i);
            } else n[t[a]][c] = e;
          } else l[c] = e;
        });
      } else "object" == typeof s ? i[c] = a(s) : l[c] = s;
    }), t.forEach(function (e) {
      n[e] && (l[e] = n[e]);
    }), Object.assign(l, i), l;
  }

  return function () {
    for (var e = arguments.length, n = Array(e), r = 0; r < e; r++) {
      n[r] = arguments[r];
    }

    return n.map(a);
  };
}(["@media only screen and (max-width: ".concat("767px", ")"), "@media only screen and (min-width: ".concat("768px", ")"), "@media only screen and (min-width: ".concat("1025px", ")")]),
    ue = l(T || (T = C(["\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  transition: opacity 150ms ease-in-out;\n"]))),
    pe = l(L || (L = C(["\n  opacity: 1;\n"]))),
    fe = l(R || (R = C(["\n  position: absolute;\n  min-height: 100%;\n  width: 100%;\n  padding: ", "px ", "px;\n  overflow-y: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), 64, 18),
    de = l(B || (B = C(["\n  transition: all 150ms ease-in-out;\n  margin: auto;\n  max-height: calc(100% - ", "px);\n  position: relative;\n  pointer-events: all;\n  transform: translate3d(0, -16px, 0);\n  opacity: 0;\n\n  &:focus {\n    outline: none;\n  }\n"])), 64),
    me = l(U || (U = C(["\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  border-radius: 24px;\n  padding: 40px 36px;\n  box-shadow: 0px 8px 20px -8px ", ";\n"])), s.gray.dark3, s.white, v.default, d(.4, u.black)),
    ye = l(V || (V = C(["\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n"]))),
    ge = {
  small: l(X || (X = C(["\n    width: 400px;\n  "]))),
  default: l($ || ($ = C(["\n    width: 600px;\n  "]))),
  large: l(q || (q = C(["\n    ", "\n  "])), se({
    width: ["720px", "720px", "960px"]
  }))
},
    be = l(G || (G = C(["\n  position: absolute;\n  cursor: pointer;\n"]))),
    he = (k(re = {}, ce, (k(W = {}, P.Default, l(H || (H = C(["\n      color: ", ";\n    "])), u.gray.base)), k(W, P.Dark, l(J || (J = C(["\n      color: ", ";\n    "])), u.gray.dark1)), k(W, P.Light, l(K || (K = C(["\n      color: ", ";\n    "])), u.white)), k(W, "position", l(Q || (Q = C(["\n      // x-icon should be 24px from edge. IconButton is 28x28 and Icon is 16x16\n      // so there's already (28 - 16) / 2 = 6px of spacing. 24 - 6 = 18.\n      right: 18px;\n      top: 18px;\n    "])))), W)), k(re, le, (k(ne = {}, P.Default, l(Y || (Y = C(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), s.gray.base, s.gray.base)), k(ne, P.Dark, l(Z || (Z = C(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), s.gray.base, s.gray.base)), k(ne, P.Light, l(_ || (_ = C(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), s.gray.base, s.gray.base)), k(ne, "position", l(ee || (ee = C(["\n      // x-icon should be 16px from edge. IconButton is 28x28 and Icon is 16x16\n      // so there's already (28 - 16) / 2 = 6px of spacing. 16 - 6 = 10.\n      right: 10px;\n      top: 10px;\n    "])))), ne)), re),
    ve = x();

function xe(o) {
  var t = o.open,
      x = void 0 !== t && t,
      O = o.size,
      N = void 0 === O ? M.Default : O,
      A = o.setOpen,
      D = void 0 === A ? function () {} : A,
      I = o.shouldClose,
      S = void 0 === I ? function () {
    return !0;
  } : I,
      z = o.darkMode,
      F = void 0 !== z && z,
      T = o.children,
      L = o.className,
      R = o.contentClassName,
      B = o.initialFocus,
      U = o.closeIconColor,
      V = void 0 === U ? P.Default : U,
      X = j(o, ie),
      $ = F ? le : ce,
      q = e.useRef(null),
      G = E(n(null), 2),
      H = G[0],
      J = G[1],
      K = a().isPopoverOpen,
      Q = r(function () {
    D && S() && D(!1);
  }, [D, S]),
      W = b({
    prefix: "modal"
  });
  h(Q, {
    enabled: x && !K
  });
  var Y = B ? {
    initialFocus: "#".concat(W, " ").concat(B),
    fallbackFocus: "#".concat(W, " .").concat(ve)
  } : {
    fallbackFocus: "#".concat(W, " .").concat(ve)
  };
  return e.createElement(f, {
    in: x,
    timeout: 150,
    mountOnEnter: !0,
    unmountOnExit: !0,
    nodeRef: q
  }, function (n) {
    var r;
    return e.createElement(m, null, e.createElement("div", w({}, X, {
      id: W,
      ref: q,
      className: c(L, ue, (r = {}, k(r, pe, "entered" === n), k(r, l(oe || (oe = C(["\n                background-color: ", ";\n              "])), d(.4, u.black)), !F), k(r, l(te || (te = C(["\n                background-color: ", ";\n              "])), d(.4, s.black)), F), r))
    }), e.createElement(p, {
      focusTrapOptions: Y
    }, e.createElement("div", {
      className: fe,
      ref: function ref(e) {
        return J(e);
      }
    }, e.createElement("div", {
      "aria-modal": "true",
      role: "dialog",
      tabIndex: -1,
      className: c(de, me, k({}, l(ae || (ae = C(["\n                        // TODO: Refresh – remove when darkMode is updated\n                        color: ", ";\n                        background-color: ", ";\n                        font-family: ", ";\n                        border-radius: 7px;\n                        padding: 32px;\n                        box-shadow: 0 5px 15px\n                          ", ";\n                      "])), s.white, s.gray.dark3, v.legacy, d(.4, s.black)), F), ge[N], k({}, ye, "entered" === n), R)
    }, e.createElement(i, {
      popover: {
        portalContainer: H,
        scrollContainer: H
      }
    }, T, e.createElement(g, {
      onClick: Q,
      "aria-label": "Close modal",
      className: c(be, he[$][V], he[$].position, ve),
      darkMode: F
    }, e.createElement(y, null))))))));
  });
}

xe.displayName = "ModalView", xe.propTypes = {
  open: o.bool,
  size: o.string,
  children: o.node,
  shouldClose: o.func,
  className: o.string,
  setOpen: o.func
};
export { P as CloseIconColor, F as Footer, M as ModalSize, xe as ModalView, S as default };